import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=12316897&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts&"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts&"
import style0 from "../../layouts/Header.scss?vue&type=style&index=0&id=12316897&lang=scss&scoped=true&"
import style1 from "./HeaderLogo.vue?vue&type=style&index=1&id=12316897&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12316897",
  null
  
)

export default component.exports